export { CardMinimalTileUi, type CardMinimalTileUiProps } from "#card-minimal-tile-ui";
